import isNode from 'detect-node';

const isFirefox = (): boolean => navigator.userAgent.toLowerCase().includes('firefox');

export const uploadToS3 = async (
  url: string,
  file: File,
  headers: { name: string; value: string }[],
): Promise<Response> => {
  const headersObj = new Headers();
  headers.forEach(({ name, value }) => {
    headersObj.append(name, value);
  });
  return fetch(url, { headers: headersObj, method: 'PUT', body: file }).then(
    (response: Response) => {
      if (!response.ok) {
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw response;
      }
      return response;
    },
  );
};

export const fileToDataUri = async (file: File): Promise<string> => {
  const fileReader = new FileReader();
  return new Promise(resolve => {
    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };
    fileReader.readAsDataURL(file);
  });
};

export const dataURItoBlob = (dataURI: string): Blob => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  const arrayBuffer = new ArrayBuffer(byteString.length);
  const intArray = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], { type: mimeString });
};

export const getVideoThumbnail = async (file: File): Promise<File> =>
  new Promise((resolve, reject) => {
    if (!isNode) {
      const video = document.createElement('video');

      video.src = URL.createObjectURL(file);

      if (!isFirefox()) {
        video.currentTime = 1;
      }

      video.oncanplaythrough = () => {
        if (isFirefox()) {
          video.currentTime = 1;
        }
        const canvas = document.createElement('canvas');

        canvas.width = video.videoWidth;

        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        if (!context) {
          throw new Error('Context did not load.');
        }
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(blob => {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          blob
            ? resolve(
                new File([blob], 'screenshot.png', {
                  type: 'image/png',
                }),
              )
            : reject(new Error('Blob was not sucessfully created.'));
        });
      };
      video.load();
    }
  });

export const getVideoDuration = async (file: File): Promise<number | null> =>
  new Promise(resolve => {
    const video = document.createElement('video');

    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(Number.isNaN(video.duration) ? null : Math.ceil(video.duration));
    };

    video.src = URL.createObjectURL(file);
  });
